import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { inject } from '@angular/core';
import { SanitizerUtil } from '@shared/utils';

export const sanitizeInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const sanitizerUtil = inject(SanitizerUtil);

  return next(req).pipe(
    map((event) => {
      if (event instanceof HttpResponse && event.body) {
        const sanitizedBody = sanitizerUtil.sanitizeData(event.body);
        return event.clone({ body: sanitizedBody });
      }
      return event;
    }),
  );
};
